/**
 * The animated FlowIQ orb as a chat launcher (`web_chat_widgets.launcher.icon
 * = "orb"`, 21 Sep 2026). Since 22 Sep 2026 it is a live WebGL shader
 * (src/lib/orb-shader.ts), drawn identically by the loader's launcher and
 * ChatWidget's toggle (src/components/OrbCanvas.tsx) on a shared clock, so
 * nothing changes when the bundle takes over. It replaced a Higgsfield video
 * clip, which was soft at 56px, blurred at its alpha edge and had to loop.
 *
 * The one asset left is the still poster, shown only where WebGL is missing.
 */

/** Same footprint as the classic 56px bubble, so the orb sits exactly where
 *  the old icon did and the open close-disc is the ordinary one. */
export const ORB_LAUNCHER_DEFAULT_SIZE = 56;

/** Public path under the widget host (public/widget-assets/, served at the
 *  domain root by the app build; the widget/loader builds skip public/). */
export const orbLauncherAssets = (base: string) => ({
  poster: `${base}/widget-assets/orb-poster.png`,
});
